import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function B() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('camp');
    const lists: any[] = [
        {
            title: t('secB_list1_title'),
            desc: t('secB_list1_desc'),
        },
        {
            title: t('secB_list2_title'),
            desc: t('secB_list2_desc'),
        },
        {
            title: t('secB_list3_title'),
            desc: t('secB_list3_desc'),
        },
    ];
    return (
        <div id="camp-B" className={`camp-B camp-box ${css['camp-B']}`}>
            <h2 className="title">{t('secB_title')}</h2>
            <p className="img-title">{t('secB_img_title')}</p>
            <div className="img-box">
                <EFPicture src={'/responsive/picture/camp/2.jpg'} alt={t('secB_title')} />
            </div>
            <p className="tip">
                {t.rich('secB_desc', {
                    a: (a: string) => (
                        <Link className="a-link" href={t('secB_desc_link')}>
                            {a}
                        </Link>
                    ),
                })}
            </p>
            <ul className="lists">
                {lists?.map((list: any, k: number) => (
                    <li className="list" key={k}>
                        <h3 className="list-title">{list?.title}</h3>
                        <p className="list-desc desc">{list?.desc}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
}
